
<template>
    <div class="robotedu-header">
        <div class="header-container clearfix">
            <router-link to="/index" class="header-logo"></router-link>
            <a class="header-item fr">
                <Button type="primary" shape="circle" icon="ios-person-outline" @click="loginBtn">登录</Button>
            </a>
            <router-link to="/company"  class="header-item fr">企业合作</router-link>
            <a href="https://orionbase.cn/" class="header-item" target="_blank">家庭机器人能力开发</a>
            <a href="https://jiedai.ainirobot.com/" class="header-item" target="_blank">服务机器人运营</a>
            <a href="https://cs.ainirobot.com/" class="header-item" target="_blank">机器人群控系统</a>
            <a :href="examUrl" class="header-item" target="_blank">猎豹教育考试系统</a>
<!--            <a class="header-item" href="http://dev.ainirobot.com/" target="_blank">-->
<!--                机器人开发-->
<!--            </a>-->
        </div>
        <Modal
                v-model="loginModal"
                title="请选择您对应的角色"
                :footer-hide="true"
               >
            <Row>
                <Col span="8" class="login-user-list">
                    <a href="javascript:;" @click="gologinFrom('admin')">
                        <img src="../../../static/admin.svg" alt="">
                        <p>学校管理员</p>
                    </a>
                </Col>
                <Col span="8" class="login-user-list">
                    <a href="javascript:;" @click="gologinFrom('teacher')">
                        <img src="../../../static/teacher.svg" alt="">
                        <p>教师</p>
                    </a>
                </Col>
                <Col span="8" class="login-user-list">
                    <a href="javascript:;" @click="gologinFrom('stu')">
                        <img src="../../../static/stu.svg" alt="">
                        <p>学生</p>
                    </a>
                </Col>
            </Row>
        </Modal>
        <Modal
                v-model="loginModalForm"
                title="登录"
                :footer-hide="true"
                width="420"
        >
            <div class="login-box">
                <Form :model="loginForm" status-icon :rules="rules" ref="loginForm" :label-width="55" >
                    <FormItem prop="username" label="账号">
                        <Input v-model="loginForm.username" placeholder="用户名/学号/邮箱"></Input>
                    </FormItem>
                    <FormItem prop="password" label="密码">
                        <Input
                                type="password"
                                v-model="loginForm.password"
                                placeholder="密码"
                                autocomplete="off"
                                @on-enter="submitLoginForm('loginForm')"
                        ></Input>
                    </FormItem>
                    <FormItem prop="captcha" label="验证码">
                        <Input
                                style="width: 90px"
                                v-model="loginForm.validCode"
                                placeholder="验证码"
                                autocomplete="off"
                                @on-enter="submitLoginForm('loginForm')"
                        ></Input>
                        <span class="captcha-box" @click="refreshCaptcha"><img class="captcha-img" :src="captchaUrl"></span>
                    </FormItem>
                    <a class="login-btn"  @click="submitLoginForm('loginForm')">登录</a>
                </Form>
            </div>
        </Modal>
    </div>
</template>

<script>
    import cookies from "vue-cookies";
    import loginApi from '@/api/login/login.js'
    import { authApi } from '@/api/base.js'
    import {mapActions, mapState} from "vuex";
    import { v1 as uuidv1 } from 'uuid';
    export default {
        name: "loginHeader",
        data(){
            const validateUsername = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请输入用户名！'));
                } else{
                    callback();
                }
            };
            const validatePass = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请输入密码！'));
                } else{
                    callback();
                }
            }
            const validateCaptcha = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请输入验证码！'));
                } else{
                    callback();
                }
            }
            return{
                examUrl:window.ILAB_COMMON_CONF.examUrl,
                loginModal:false,
                loginModalForm:false,
                uuidv1:uuidv1(),
                captchaUrl:'',
                loginForm:{
                    iSsubmit:false,
                    username:'',
                    password:'',
                    validCode:'',
                    grant_type:'password',
                    scope:'all',
                    client_id:'web_app_teaching',
                    client_secret:'RicK80oS'
                },
                rules: {
                    username: [
                        { validator: validateUsername, trigger: 'blur' }
                    ],
                    password: [
                        { validator: validatePass, trigger: 'blur' }
                    ],
                    captcha: [
                        { validator: validateCaptcha, trigger: 'blur' }
                    ],
                },
                loginType:''
            }
        },
        computed: {
            ...mapState({
                captcha_info: state => state.loginState.captcha_info,
                user_menus_info: state => state.loginState.user_menus_info,
            }),
        },
        methods:{
            ...mapActions({
                get_user_info_new: 'loginState/get_user_info_new',
                get_user_menus: 'loginState/get_user_menus',
            }),
            loginBtn(){
                this.loginModalForm = true
                this.captchaUrl = `${authApi}api-auth/validata/code/${this.uuidv1}`
                this.loginType = 'teacher'
            },
            //刷新验证码
            refreshCaptcha(){
                this.captchaUrl = `${authApi}api-auth/validata/code/${this.uuidv1}?timestamp=${(new Date).getTime()}`
            },
            gologinFrom(type){
                this.captchaUrl = `${authApi}api-auth/validata/code/${this.uuidv1}`
                this.loginType = type
                // this.loginModal = false
                // this.loginModalForm = true
            },
            goLogin(){
                let _this = this
                this.loginForm.deviceId = this.uuidv1
                if(!this.iSsubmit){
                    _this.iSsubmit = true
                    loginApi.newLogin(_this.loginForm).then((response) => {
                        if (response.data.access_token) {
                            cookies.set('session', response.data.access_token,60 * 60 * 3)
                            cookies.set('refresh_token', response.data.refresh_token,60 * 60 * 3)
                            _this.get_user_info_new({
                                session:response.data.access_token,
                                callback:()=>{}
                            })
                            _this.get_user_menus({
                                session:response.data.access_token,
                                callback:menus=>{
                                    if(menus[0]){
                                        _this.$router.push({path: menus[0].url})
                                        _this.iSsubmit = false
                                        _this.$Message.success('登录成功!');
                                    }
                                }
                            })
                            // loginApi.get_menus({id:response.data.access_token}).then((response) => {
                            //     if(response.data){
                            //         if(response.data[0]){
                            //             _this.$router.push({path: response.data[0].url,params: {session: response.data.access_token}})
                            //             _this.iSsubmit = false
                            //             _this.$Message.success('登录成功!');
                            //         }
                            //     }
                            // })
                            // _this.$router.push({name: 'courses',params: {session: response.data.access_token}})
                            // _this.iSsubmit = false
                        }else{
                            _this.$Message.error(response.data.message);
                            _this.iSsubmit = false
                        }
                    }).catch(function (error) {
                        _this.iSsubmit = false
                        _this.$Message.error(error.data.message);
                    });
                }
            },
            submitLoginForm(loginForm){
                let _this = this
                if(this.loginType !== 'teacher'){
                    this.$Message.error('账号不存在!');
                }else{
                    this.$refs[loginForm].validate((valid) => {
                        if (valid) {
                            _this.goLogin()

                        } else {
                            console.log('error submit!!');
                            return false;
                        }
                    });
                }
            }
        },
    }
</script>

    <style lang="less" >
        .robotedu-header{
            position: fixed;
            left: 0;
            top: 0;
            z-index: 11;
            width: 100%;
            height: 60px;
            background-color: #232730;
            line-height: 60px;
            .header-container{
                width: 100%;
                min-width: 1200px;
                height: 100%;
                box-sizing: border-box;
                padding: 0px 30px;
                font-size: 0;
                .ivu-dropdown-item{
                    padding: 7px 0;
                    a{
                        color: #3a3a3a;
                    }
                    a:hover{
                        color: rgba(20,121,242,1);
                    }
                }
                .ivu-dropdown-item:hover{
                    background: #ffffff;
                }
            }
            .header-logo{
                display: inline-block;
                vertical-align: middle;
                text-align: center;
                color: #fff;
                line-height: 60px;
                margin: 0 30px 0 0;
                height: 32px;
                width: 178px;
                background: url("./style/logo2.png") no-repeat;
                background-size: cover;

            }
            .header-item,.login-item{
                display: inline-block;
                vertical-align: middle;
                padding: 0 20px;
                font-size: 14px;
                text-align: center;
                color: #fff!important;
                line-height: 60px;
                font-weight: 700;
                .dropdown-a{
                    color: #fff;
                }
                .dropdown-a:hover{
                    color: rgba(20,121,242,1);
                }
            }
            .header-item:hover{
                color: rgba(20,121,242,1)!important;
            }
            .ivu-btn-primary {
                color: #fff;
                background-color: rgba(20,121,242,1);
                border-color: rgba(20,121,242,1);
            }
            .ivu-btn > .ivu-icon{
                font-size: 18px;
            }
        }
        .login-user-list{
            text-align: center;
            a {
                height: 150px;
                width: 143px;
                display: inline-block;
                padding-top: 33px;
                box-sizing: border-box;
                p {
                    color: #666;
                    padding-top: 10px;
                    font-size: 16px;
                }
            }
            img{
                width: 70px;
                height:63px ;
            }
            a:hover{
                background: #ebeced;
            }

        }
        .login-box{
            width: 240px;
            margin: 0 auto;
            padding-bottom: 30px;
            .login-btn{
                display: inline-block;
                font-size: 12px;
                width: 240px;
                height: 30px;
                line-height: 30px;
                color: #fff!important;
                padding: 0 30px;
                background-color: #1479f2;
                text-align: center;
                box-sizing: border-box;
                outline: 0;
            }
            .login-btn:hover{
                background-color: #0092ee;
            }


        }
        .dropdown-item{
            background: #ffffff!important;
        }
        .captcha-box{
            display: inline-block;
            margin-left: 10px;
        }
        .captcha-img{
            cursor: pointer;
            width: 80px;
            height: 33px;

        }
    </style>
